import { useMemo } from "react";
import { useAppointmentCommunicationConfigQuery } from "@/graphql/queries/appointment/appointmentCommunicationConfig.graphql.types";
import {
  CommunicationConfig,
  defaultApptCommunicationState,
} from "@/hooks/appointments/useApptCustomizedCommunication";

export default function useDefaultCommunicationConfig(
  appointmentId: string,
  invoiceId: string,
  queryEnabled = true
) {
  const { data } = useAppointmentCommunicationConfigQuery({
    variables: {
      appointmentId,
      invoiceId,
    },
    skip: !appointmentId || !invoiceId || !queryEnabled,
    fetchPolicy: "cache-and-network",
  });

  const defaultConfiguration = useMemo(() => {
    if (!data) return null;

    const communicationFields: (keyof CommunicationConfig)[] = Object.keys(
      defaultApptCommunicationState
    ).flatMap((key) => [
      `${key}Sms` as keyof CommunicationConfig,
      `${key}Mail` as keyof CommunicationConfig,
    ]);

    const medspaConfig = data?.appointmentByPk?.medspa?.configuration;
    const appointmentOverrides = data?.appointmentByPk?.appointmentConfig;
    const invoiceOverrides = data?.invoiceByPk;

    const config = {} as CommunicationConfig;

    communicationFields.forEach((field) => {
      const invoiceValue = invoiceOverrides?.[field];
      const appointmentValue = appointmentOverrides?.[field];
      const medspaValue = medspaConfig?.[field];

      config[field] = invoiceValue ?? appointmentValue ?? medspaValue;
    });

    return config;
  }, [data]);

  return {
    defaultConfiguration,
    hasOverride: !!data?.appointmentByPk?.appointmentConfig,
  };
}
